module.exports = {
  MACRON: {
    lib: 'Emmanuel Macron',
    score: 66.1,
    color: '#FFC107' // amber
  },
  LEPEN: {
    lib: 'Marine Le Pen',
    score: 33.9,
    color: '#607D8B' // blue grey
  }
}



// WEBPACK FOOTER //
// ./src/candidats.js